import { useEffect, useState } from "react";
import Dropdown from "../../UiComponents/Dropdown";
import { getCity } from "./filteringUtils";

const CitySelector = props => {
    const [selectedCity, setSelectedCity] = useState(props.selectedCity ?? null);
    const [cities, setCities] = useState();

    const onSelectCity = (city) => {
        setSelectedCity(city);
        if (props.onSelect) {
            props.onSelect(city ?? null);
        }
    }

    useEffect(() => {
        const distinctCities = props.customers?.
            map(customer => getCity(customer))?.
            filter((city) => city !== null)?.
            filter((customer, index, array) => array?.indexOf(customer) === index)?.
            map(city => { return { key: city, label: city } })?.
            sort((a, b) => a?.label > b?.label ? 1 : -1);
        setCities(distinctCities);
    }, [props.customers])

    return <>
        <Dropdown
            items={cities}
            selectedItem={selectedCity}
            onClick={(city) => onSelectCity(city)}
            placeholder={'Filter city'}
            clearable
        />
    </>
}

export default CitySelector;